'use strict';
(() => {
  if (!['water', 'sterile', 'bacteriostaticSaline', 'saline', 'syringes', 'needles'].includes(document.body.dataset.page) || document.documentElement.hasAttribute('data-bw-water-nav-ready')) return;
  document.documentElement.setAttribute('data-bw-water-nav-ready', '');
  let cleanup = () => {};

  function setup() {
    cleanup();
    const main = document.getElementById('main');
    const nav = main?.querySelector('[data-bw-water-nav]');
    const strip = nav?.querySelector('.wrap');
    const header = document.querySelector('.bw-shopify-header');
    if (!main || !nav || !strip) return;
    const entries = Array.from(nav.querySelectorAll('a[href^="#"]')).map(link => ({
      link, target: document.getElementById(link.hash.slice(1)),
    })).filter(entry => entry.target);
    if (!entries.length) return;
    let frame = 0;
    let clearance = 0;
    let current = null;
    let disposed = false;

    function revealLink(link) {
      // Scroll only the link strip, never the document or keyboard focus.
      if (nav.contains(document.activeElement) && document.activeElement !== link) return;
      const bounds = strip.getBoundingClientRect();
      const item = link.getBoundingClientRect();
      if (item.left < bounds.left + 8) strip.scrollLeft += item.left - bounds.left - 8;
      else if (item.right > bounds.right - 8) strip.scrollLeft += item.right - bounds.right + 8;
    }

    function update() {
      frame = 0;
      if (!nav.isConnected) return;
      let active = entries[0];
      for (const entry of entries) {
        if (entry.target.getBoundingClientRect().top <= clearance + 2) active = entry;
      }
      if (active === current) return;
      entries.forEach(entry => {
        if (entry === active) entry.link.setAttribute('aria-current', 'location');
        else entry.link.removeAttribute('aria-current');
      });
      current = active;
      revealLink(active.link);
    }

    function schedule() {
      if (!frame) frame = requestAnimationFrame(update);
    }

    function measure() {
      if (disposed || !nav.isConnected) return;
      const headerHeight = Math.ceil(header?.getBoundingClientRect().height || 0);
      clearance = headerHeight + Math.ceil(nav.getBoundingClientRect().height) + 12;
      const rootPadding = parseFloat(getComputedStyle(document.documentElement).scrollPaddingTop) || 0;
      main.style.setProperty('--bws-header-height', headerHeight + 'px');
      main.style.setProperty('--bws-scroll-margin', Math.max(0, clearance - rootPadding) + 'px');
      schedule();
    }

    function focusLink(event) {
      const link = event.target.closest('a');
      if (link) revealLink(link);
    }

    function revealHashTarget() {
      let id;
      try { id = decodeURIComponent(window.location.hash.slice(1)); } catch (_) { return; }
      let disclosure = document.getElementById(id)?.closest('details');
      while (disclosure) {
        disclosure.open = true;
        disclosure = disclosure.parentElement?.closest('details');
      }
      schedule();
    }

    window.addEventListener('scroll', schedule, { passive: true });
    window.addEventListener('resize', measure, { passive: true });
    window.addEventListener('hashchange', revealHashTarget);
    nav.addEventListener('focusin', focusLink);
    const observer = window.ResizeObserver ? new ResizeObserver(measure) : null;
    if (header) observer?.observe(header);
    observer?.observe(nav);
    observer?.observe(main);
    document.fonts?.ready.then(measure);
    revealHashTarget();
    measure();

    cleanup = () => {
      disposed = true;
      cancelAnimationFrame(frame);
      observer?.disconnect();
      window.removeEventListener('scroll', schedule);
      window.removeEventListener('resize', measure);
      window.removeEventListener('hashchange', revealHashTarget);
      nav.removeEventListener('focusin', focusLink);
    };
  }

  document.addEventListener('shopify:section:load', setup);
  document.addEventListener('shopify:section:reorder', setup);
  document.addEventListener('shopify:section:unload', () => requestAnimationFrame(setup));
  setup();
})();
